module.exports = __webpack_public_path__ + "img/06.3e428fe3.jpg";